export const DATEPICKER_PRESET_LAST_WEEK = 'last_week';
export const DATEPICKER_PRESET_YESTERDAY = 'yesterday';
export const DATEPICKER_PRESET_TODAY = 'today';
export const DATEPICKER_PRESET_CURRENT_WEEK = 'current_week';
export const DATEPICKER_PRESET_CURRENT_MONTH = 'current_month';
export const DATEPICKER_PRESET_CURRENT_YEAR = 'current_year';
export const DATEPICKER_PRESET_CUSTOM = 'custom';
export const DATEPICKER_PRESET_LAST_3_DAYS = 'last_3_days';
export const DATEPICKER_PRESET_LAST_MONTH = 'last_month';

export const DATEPICKER_PRESETS = [
  DATEPICKER_PRESET_LAST_WEEK,
  DATEPICKER_PRESET_YESTERDAY,
  DATEPICKER_PRESET_TODAY,
  DATEPICKER_PRESET_LAST_3_DAYS,
  DATEPICKER_PRESET_CURRENT_WEEK,
  DATEPICKER_PRESET_CURRENT_MONTH,
  DATEPICKER_PRESET_CURRENT_YEAR,
  DATEPICKER_PRESET_LAST_MONTH
] as const;

export type DATEPICKER_PRESET = typeof DATEPICKER_PRESETS[number];

export const DATEPICKER_PRESETS_MAPPED = {
  Last_week: DATEPICKER_PRESET_LAST_WEEK as DATEPICKER_PRESET,
  Yesterday: DATEPICKER_PRESET_YESTERDAY as DATEPICKER_PRESET,
  Today: DATEPICKER_PRESET_TODAY as DATEPICKER_PRESET,
  Last_3_days: DATEPICKER_PRESET_LAST_3_DAYS as DATEPICKER_PRESET,
  Current_week: DATEPICKER_PRESET_CURRENT_WEEK as DATEPICKER_PRESET,
  Current_month: DATEPICKER_PRESET_CURRENT_MONTH as DATEPICKER_PRESET,
  Current_year: DATEPICKER_PRESET_CURRENT_YEAR as DATEPICKER_PRESET,
  Last_month: DATEPICKER_PRESET_LAST_MONTH as DATEPICKER_PRESET
};
